const sectionsSubPopup = () => {
    const handleItemClick = (event) => {
        const item = event.currentTarget;
        const itemTextContainer = item.querySelector('.sections-sub-popup__text-container');

        if (itemTextContainer) {
            const isMobile = window.innerWidth <= 575;
            const isTablet = window.innerWidth > 575 && window.innerWidth <= 991;

            // клик на планшете - показывает подразделы
            if (isTablet) {
                itemTextContainer.classList.add('sections-sub-popup__text-container_active');
            }

            // на мобильном - сразу переход в раздел без показа подразделов
            if (isMobile) {
                const titleLink = itemTextContainer.querySelector('.sections-sub-popup__title')?.getAttribute('href');
                if (titleLink) {
                    window.location.href = titleLink;
                }
            }
        }
    };

    document.querySelectorAll('.sections-sub-popup__item').forEach(item => {
        item.addEventListener('click', handleItemClick);
    });
};

export default sectionsSubPopup;
